// extracted by css-extract-rspack-plugin
export default {"SavedEntityPickerRoot":"z4OAe","CollectionsContainer":"CH_W8","BackButton":"j6fcb"};